import styled from "styled-components";

const hoverEase = "cubic-bezier(0.4, 0, 0.2, 1)";
const springEase = "cubic-bezier(0.34, 1.56, 0.64, 1)";

export const ArrowIcon = styled.img`
  width: 15px;
  height: 16px;
  object-fit: contain;
  flex-shrink: 0;
  filter: invert(26%) sepia(98%) saturate(6943%) hue-rotate(218deg) brightness(101%) contrast(104%);
  transition: transform 0.35s ${springEase}, opacity 0.3s ${hoverEase};
`;

export const StyledAnonymousQuestionItem = styled.li`
  padding: 10px 5px 15px;
  padding-inline-start: 0;
  padding-inline-end: 1rem;
  border-bottom: 0.5px solid #7e8aad33;
  background-color: transparent;
  display: flex;
  align-items: center;
  gap: 12px;
  direction: rtl;
  cursor: pointer;
  transition:
    background-color 0.35s ${hoverEase},
    box-shadow 0.35s ${hoverEase},
    transform 0.35s ${hoverEase},
    border-color 0.35s ${hoverEase};

  &:hover {
    background-color: #f5f7ff;
    box-shadow: 0 6px 20px rgba(18, 34, 67, 0.07);
    transform: translateY(-2px);
    border-bottom-color: rgba(126, 138, 173, 0.12);
  }

  &:active {
    transform: translateY(-1px);
    transition-duration: 0.15s;
  }

  &:hover ${ArrowIcon} {
    transform: translateX(-3px);
    opacity: 0.92;
  }

  .question-content {
    flex: 1;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: -0.29px;
    text-align: right;
    color: #122243;
    line-height: 1.5;
    word-break: break-word;
    padding-top: 0.25rem;
    white-space: pre-line;
    transition: color 0.3s ${hoverEase};
  }

  &:hover .question-content {
    color: #0d1a35;
  }
`;

export const TrashButton = styled.button`
  background: none;
  border: none;
  border-left: 0.5px solid #7e8aad33;
  cursor: pointer;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    background-color 0.3s ${hoverEase},
    transform 0.25s ${hoverEase},
    border-color 0.3s ${hoverEase};
  flex-shrink: 0;
  min-width: 32px;
  min-height: 32px;
  opacity: 1;
  border-radius: 6px;

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    transition: transform 0.3s ${springEase};
  }

  &:hover {
    background-color: rgba(126, 138, 173, 0.12);
  }

  &:hover img {
    transform: scale(1.06);
  }

  &:active {
    transform: scale(0.96);
  }
`;

export const TotalQuestionsBadge = styled.span`
  width: 18px;
  height: 18px;
  min-width: 18px;
  min-height: 18px;
  border-radius: 50%;
  background: #ff2d55;
  color: #ffffff;
  font-family: "Noto Sans Hebrew", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  letter-spacing: -0.22px;
  text-align: center;
  vertical-align: middle;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.3s ${springEase};

  ${StyledAnonymousQuestionItem}:hover & {
    transform: scale(1.08);
  }
`;

export const CreatedDate = styled.span`
  font-family: "Noto Sans Hebrew", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 13.59px;
  letter-spacing: -0.29px;
  text-align: center;
  vertical-align: middle;
  color: #7e8aad;
  padding: 4px 8px;
  border-radius: 4px;
  flex-shrink: 0;
  white-space: nowrap;
  transition: color 0.3s ${hoverEase};

  ${StyledAnonymousQuestionItem}:hover & {
    color: #637099;
  }
`;
